import styled from '@emotion/styled'
import { colors, spacing } from '@mobi/component-library/Foundations'

export const TabsScrollContainerStyled = styled.ul({
  position: 'relative',
  display: 'flex',
  alignItems: 'stretch',
  gap: spacing.md,
  borderSpacing: 0,
  width: '100%',
  minHeight: '4.8rem',
  padding: 0,
  margin: 0,
  listStyle: 'none',

  paddingInline: spacing.md,

  overflowX: 'auto',
  overscrollBehaviorX: 'contain',
  scrollBehavior: 'smooth',
  WebkitOverflowScrolling: 'touch',
  WebkitTapHighlightColor: 'transparent',
  scrollbarWidth: 'thin',
  scrollbarColor: colors.neutral[300] + ' ' + colors.surface[50],

  '@media (pointer: coarse)': {
    scrollbarWidth: 'none',
    '::-webkit-scrollbar': { display: 'none' },
  },
})

export const TabGroupStyled = styled.div({
  borderBottom: `0.05rem solid ${colors.neutral[400]}`,
})
